<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
const emits = defineEmits<{ (e: 'close'): void }>();
const { $t } = useNuxtApp();
</script>

<template>
  <header class="sticky top-0">
    <div class="flex items-center justify-between p-4 bg-base">
      <span class="text-base-priority font-bold text-lg">
        {{ $t('notifications') }}
      </span>
      <LazyDesignSystemButton
        element-name="close-notifications-panel"
        type="tertiary"
        size="medium"
        rounding="md"
        aria-label="Close"
        @click="emits('close')"
      >
        <span class="sr-only">{{ $t('close') }}</span>
        <XMarkIcon />
      </LazyDesignSystemButton>
    </div>
  </header>
</template>
